import { render, staticRenderFns } from "./quiz_question.vue?vue&type=template&id=cffd423e&scoped=true&"
import script from "./quiz_question.vue?vue&type=script&lang=js&"
export * from "./quiz_question.vue?vue&type=script&lang=js&"
import style0 from "./quiz_question.vue?vue&type=style&index=0&id=cffd423e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cffd423e",
  null
  
)

export default component.exports